<template>
  <v-autocomplete
    item-text="title"
    :items="classList"
    :chips="chips"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
    :return-object="returnObject"
    :rules="rules"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    v-bind="$attrs"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Class } from '@/plugins/api'

export default {
  data: () => ({
    classes: []
  }),
  props: {
    filter: Object,
    defaultClasses: Array,
    allClasses: Array,
    chips: {
      type: Boolean,
      default: true
    },
    deletableChips: {
      type: Boolean,
      default: true
    },
    smallChips: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => [v => !!v || 'Item is required']
    }
  },
  computed: {
    ...mapGetters('app', ['department', 'roles', 'roleIdByName']),
    filteredClasses() {
      if (!this.allClasses) {
        return this.classes
      }
      return this.classes.filter(item => {
        return this.allClasses.includes(item.id)
      })
    },
    classList() {
      return this.filteredClasses.map(c => ({ ...c, title: `${c.code} - ${c.title}` }))
    }
  },
  created() {
    console.log('hello', this.$attrs)
    this.classes = this.defaultClasses || []
    this.fetchClass()
  },
  methods: {
    async fetchClass() {
      this.classes = await Class.fetch({
        ...this.filter,
        department: this.department.id,
        status_in: ['opened', 'running']
      })
    },
    onChange(data) {
      this.$emit('change', data)
    }
  },
  watch: {
    filters(filters) {
      this.fetchClass()
    }
  }
}
</script>
